import { API_URLS } from '@helpers/api';
import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { SocialMediaIcon } from '@stories/Components/Misc/SocialLinks/SocialLinks';
import React from 'react';
import { FocusRing } from 'react-aria';
import { SharePrintSaveStyles as S } from './SharePrintSave.styles';
const SharePrintSave = (props) => {
    /*
    Disable browser share button initially. Do check on first render,
    then enable to prevent CLS issues.
    */
    const [canShare, setCanShare] = React.useState(true);
    const [isSaved, setIsSaved] = React.useState(props.pageSaved ?? false);
    React.useEffect(() => {
        setCanShare(typeof window != 'undefined' && window.navigator && 'share' in window.navigator);
    }, []);
    const shareData = {
        title: props.shareTitle,
        url: props.shareUrl,
    };
    const toggleSavePage = async (payload) => {
        try {
            const response = await fetch(API_URLS.savePage, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = (await response.json());
            setIsSaved(data.isSaved);
        }
        catch (error) {
            console.error('Error saving page:', error);
        }
    };
    return (React.createElement(S.Container, { id: props.anchorId, translations: props.translations, flush: "both" },
        React.createElement(S.Inner, null,
            React.createElement(S.LinkList, null,
                React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { as: "button", title: (props.translations && props.translations['global.print']) ?? '', type: "button", onClick: () => window.print() },
                            React.createElement(S.Icon, null, getSvgIcon(InterfaceIcon.Print)),
                            ' ',
                            (props.translations && props.translations['global.print']) ?? ''))),
                canShare ? (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { as: "button", title: (props.translations && props.translations['global.share']) ?? '', type: "button", onClick: (event) => {
                                event.preventDefault();
                                share(shareData);
                            }, disabled: !canShare },
                            React.createElement(S.Icon, null, getSvgIcon(InterfaceIcon.Share)),
                            ' ',
                            (props.translations && props.translations['global.share']) ?? '')))) : (props.options.map(renderButton)),
                props.isLoggedIn && (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { as: "button", title: !isSaved
                                ? (props.translations && props.translations['global.save']) ?? ''
                                : (props.translations && props.translations['global.remove']) ?? '', type: "button", onClick: () => toggleSavePage({ pageId: props.pageId, isSaved: !isSaved }) },
                            React.createElement(S.Icon, { "data-saved": isSaved }, !isSaved ? getSvgIcon(InterfaceIcon.Plus) : getSvgIcon(InterfaceIcon.Close)),
                            !isSaved
                                ? (props.translations && props.translations['global.save']) ?? ''
                                : (props.translations && props.translations['global.remove']) ?? ''))))))));
    function renderButton(option) {
        switch (option) {
            case 'facebook':
                return (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { href: getFacebookUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: (props.translations && props.translations['global.social.facebook']) ?? '' },
                            React.createElement(S.Icon, null, getSvgIcon(SocialMediaIcon.Facebook)),
                            (props.translations && props.translations['global.social.facebook']) ?? ''))));
            case 'twitter':
                return (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { href: getTwitterUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: (props.translations && props.translations['global.social.x']) ?? '' },
                            React.createElement(S.Icon, null, getSvgIcon(SocialMediaIcon.X)),
                            (props.translations && props.translations['global.social.x']) ?? ''))));
            case 'linkedin':
                return (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { href: getLinkedInUrl(shareData), rel: "noreferrer noopener", target: "_blank", title: (props.translations && props.translations['global.social.linkedin']) ?? '' },
                            React.createElement(S.Icon, null, getSvgIcon(SocialMediaIcon.LinkedIn)),
                            (props.translations && props.translations['global.social.linkedin']) ?? ''))));
            case 'mail':
                return (React.createElement(S.Item, null,
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.Link, { href: `mailto:?body=${shareData.url}.`, title: (props.translations && props.translations['global.social.mail']) ?? '' },
                            React.createElement(S.Icon, null, getSvgIcon(InterfaceIcon.Mail)),
                            (props.translations && props.translations['global.social.mail']) ?? ''))));
            default:
                throw new Error(`Unknown share option`);
        }
    }
};
export default SharePrintSave;
function getFacebookUrl(data) {
    return `https://www.facebook.com/sharer/sharer.php?u=${data.url}`;
}
function getLinkedInUrl(data) {
    return `https://www.linkedin.com/shareArticle?title=${data.title}&url=${data.url}`;
}
function getTwitterUrl(data) {
    return `https://twitter.com/intent/tweet?text=${data.title}&url=${data.url}`;
}
/**
 * Attempt to share using the Web Share API.
 * @param data The share data
 */
function share(data) {
    return navigator.share(data);
}
